// Email : any letter/number/special character (at least one) then @ then any letter/number (at least one) then point then any letter/number (at least one)
export const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/

// Password : 1 lowercase, 1 uppercase, 1 numeric, 1 special, 8 characters or longer
export const passwordRegex = new RegExp(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%&*?:])(?=.{8,})/
  );